<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              v-model="form.searchKey"
              type="search"
              :placeholder="$l('table_contactName_manufacturerName') ||'联系人/手机/电话/公司/公司地址搜索...'"
            />
            <b-input-group-append>
              <b-button-group>
               
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search"></i>
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,

      form: {
        searchKey: '',
      },
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {
    //this.onReset();
  },
  methods: {
   
    onReset() {
      this.form = {
        searchKey: '',
      }
      this.$emit('reset')
      this.query()
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
